import { Component, ElementRef, OnChanges, SimpleChanges, input, viewChild } from '@angular/core';

import * as echarts from 'echarts/core';
import * as types from './echart-types';

import { BarChart, LineChart, PieChart, ScatterChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DatasetComponent,
  ToolboxComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { NgxEchartsDirective } from 'ngx-echarts';

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  ScatterChart,
  GridComponent,
  LegendComponent,
  DatasetComponent,
  BarChart,
  LineChart,
  PieChart,
  CanvasRenderer,
]);

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss'],
  imports: [NgxEchartsDirective],
})
export class GraphComponent implements OnChanges {
  readonly chartContainer = viewChild.required<ElementRef>('chartContainer');
  readonly chartOptions = input.required<types.EChartsOption>();

  // Trigger to force re-render (useful when dynamically changing chart types/data)
  chartOptionsCloned!: types.EChartsOption;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chartOptions']) {
      this.chartOptionsCloned = { ...this.chartOptions() }; // trigger change detection
    }
  }
}
